export default "__VITE_ASSET__CPM_Ttco__"